import { defineStyle } from "@chakra-ui/react";

export const LiveStreamingStyles = () => {
  return {
    practiceUserContainer: defineStyle({
      marginBottom: "20px",
      paddingBottom: "20px",
      marginLeft: { base: "-10px", md: "0px" },
    }),
    doubtUserContainer: defineStyle({
      marginLeft: { base: "-14px", md: "0px" },
      paddingY: "20px",
    }),
    generalUserContainer: defineStyle({
      marginBottom: "0px",
    }),
    practiceAssistantContainer: defineStyle({
      marginTop: "-20px",
      marginLeft: { base: "40px", md: "50px", lg: "50px" },
    }),
    doubtAssistantContainer: defineStyle({
      marginBottom: "12px",
      marginLeft: { base: "40px", md: "40px", lg: "50px" },
    }),
    generalAssistantContainer: defineStyle({
      marginLeft: 0,
    }),
    // doubtLiveStreamingGridContainer: defineStyle({
    //   display: "grid",
    //   gridTemplateColumns: "repeat(14,1fr)",
    //   gap: "24px",
    // }),
    // doubtSubContainer: defineStyle({
    //   gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
    // }),
    doubtLiveStreamingPlayground: defineStyle({
      marginLeft: { base: "40px", md: "40px", lg: "60px" },
    }),
  };
};
